import React from 'react';

/**
 * Reusable notes / comments textarea placed at the bottom of each wizard step.
 */
export default function NotesInput({
  value,
  onChange,
  label = 'Notes / Comments',
  placeholder = "Add any clarifications or notes you'd like your advisor to see…",
}) {
  return (
    <div className="mt-4 pt-3 border-top">
      <label className="form-label text-muted small fw-semibold" htmlFor="step-notes">
        {label} <span className="fw-normal">(optional)</span>
      </label>
      <textarea
        id="step-notes"
        className="form-control"
        rows={4}
        placeholder={placeholder}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}